// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ihvK","top":"styles_top__1eT0O","left":"styles_left__1Slna","description":"styles_description__2DKsx"};